import { useState, useEffect } from "react";
import { CLMButtonPrimary, CLMButtonSecondary } from "../v3/Buttons";
import Image from "next/image";

const ClmShowcaseSection = ({ heading, desc, showcaseData }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [underlineWidth, setUnderlineWidth] = useState(0);

  const activeItem = showcaseData[activeIndex];

  useEffect(() => {
    setUnderlineWidth(0); // Reset underline width

    const duration = activeItem.videoLength * 1000; // duration in ms
    const steps = duration / 100; // update every 100ms
    const increment = 100 / steps;

    let currentWidth = 0;
    const interval = setInterval(() => {
      currentWidth += increment;

      if (currentWidth >= 100) {
        clearInterval(interval);
        setActiveIndex((prev) => (prev + 1) % showcaseData.length); // advance to next
      }

      setUnderlineWidth(Math.min(currentWidth, 100));
    }, 100);

    return () => clearInterval(interval); // clear interval on unmount or index change
  }, [activeIndex]);

  return (
    <>
      <h3 className="text-4xl md:text-5xl leading-snug mx-auto font-semibold w-[850px] max-w-full">
        {heading}
      </h3>
      <p className="mt-5 w-[85%] md:w-[50%] mx-auto text-[18px] font-medium  max-w-full">
        {desc}
      </p>

      <div className="md:flex-row md:flex hidden flex-col mt-20 justify-center items-center w-full gap-6">
        {/* Navigation */}
        <div className="flex-1 md:w-auto w-full">
          <div className="flex flex-col ">
            {showcaseData.map((item, idx) => {
              const isActive = activeIndex === idx;

              return (
                <button
                  key={item.id}
                  className={`relative h-[46px] bg-transparent border-t  text-gray-600 flex justify-start items-center gap-4 hover:bg-black/ ${
                    isActive ? "border-gray-900 font-bold" : "border-gray-300"
                  }`}
                  onClick={() => setActiveIndex(idx)}
                >
                  <span
                    className={`rounded-full border border-black flex justify-center items-center w-7 h-7 font-light ${
                      isActive
                        ? "bg-black text-white"
                        : "text-black bg-transparents"
                    }`}
                  >
                    {idx + 1}
                  </span>
                  <span className="relative z-10 whitespace-nowrap">
                    {item.navText}
                  </span>
                  <span
                    className="absolute top-0 left-0 h-0.5 bg-dark transition-all ease-linear"
                    style={{
                      width: isActive ? `${underlineWidth}%` : "0%",
                    }}
                  />
                </button>
              );
            })}
          </div>
        </div>

        {/* Video */}
        <div className="md:w-[490px] md:h-[752px] w-[60%] h-auto md:rounded-[40px] rounded-[20px] border-white border-[10px] overflow-hidden">
          {activeItem.imgSrc && (
            <Image
              src={activeItem.imgSrc}
              alt="video"
              width={490}
              height={752}
              className="w-full h-full object-cover"
            />
          )}
          {!activeItem.imgSrc && (
            <video
              className="w-full h-full object-cover"
              key={activeItem.videoURL}
              src={activeItem.videoURL}
              autoPlay
              muted
              loop
            />
          )}
        </div>

        {/* Description */}
        <div className="flex-1 text-left">
          {/* <Image
            src={activeItem.icon}
            alt="icon"
            width={56}
            height={56}
            className="hidden md:block"
          /> */}
          <h2 className="text-2xl md:text-4xl leading-snug mt-2 font-bold">
            {activeItem.heading}
          </h2>
          <p className="mt-6 text-[18px] leading-[26px] font-medium  mb-10">
            {activeItem.desc}
          </p>
          {/* show button only if buttontext and buttonurl exists */}
          {activeItem.buttonText && activeItem.buttonClickURL && (
            <CLMButtonPrimary
              buttonText={activeItem.buttonText}
              buttonUrl={activeItem.buttonClickURL}
            />
          )}
        </div>
      </div>
      <div className="flex md:hidden flex-col gap-16 w-full mt-20  ">
        {showcaseData.map((item, idx) => {
          return (
            <div key={item.id} className=" w-full">
              {/* Navigation Button Block */}
              <div className="flex-1 md:w-auto w-full">
                <button
                  className={`relative h-[46px] bg-transparent border-t text-gray-600 flex justify-start items-center gap-4 hover:bg-black/5 border-gray-900 font-bold w-full`}
                >
                  <span
                    className={`rounded-full border border-black flex justify-center items-center w-7 h-7 font-light bg-black text-white`}
                  >
                    {idx + 1}
                  </span>
                  <span className="relative z-10">{item.navText}</span>
                </button>
              </div>
              {/* Description Block */}
              <div className=" flex-1 text-left ">
                <h2 className="text-2xl leading-snug mt-2 font-semibold">
                  {item.heading}
                </h2>
                <p className="mt-6 mb-10">{item.desc}</p>
              </div>

              {/* Video Block */}
              <div className="w-[60%] h-auto  rounded-[20px] border-white border-[10px] overflow-hidden mx-auto">
                {item.imgSrc && (
                  <Image
                    src={item.imgSrc}
                    alt="video"
                    width={490}
                    height={752}
                    className="w-full h-full object-cover"
                  />
                )}
                {!item.imgSrc && (
                  <video
                    className="w-full h-full object-cover"
                    key={item.videoURL}
                    src={item.videoURL}
                    autoPlay
                    muted
                    loop
                  />
                )}
              </div>
              <div className="w-full text-center mt-10">
                {/* show button only if buttontext and buttonurl exists */}
                {activeItem.buttonText && activeItem.buttonClickURL && (
                  <CLMButtonSecondary
                    buttonText={item.buttonText}
                    buttonUrl={item.buttonClickURL}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ClmShowcaseSection;
